@if (drawerMode() === 'over') {
  <mat-toolbar class="mat-elevation-z6 bg-primary txt-primary-contrast">
    <button mat-icon-button (click)="toggleDrawer()">
      <mat-icon>menu</mat-icon>
    </button>

    {{ appConfig.title }}

    <span class="toolbar-filler"></span>

    <button mat-icon-button (click)="toggleSearch()">
      <mat-icon>search</mat-icon>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="profileMenu">
      <mat-icon class="example-icon">person</mat-icon>
    </button>
  </mat-toolbar>
}

<mat-sidenav-container>
  <mat-sidenav [mode]="drawerMode()" [opened]="drawerOpened()" (scroll)="onMenuScroll($event)">
    @if (drawerMode() !== 'over') {
      <header class="flex flex-col items-center m-4 mb-0">
        <h1 class="w-4/5">
          <a routerLink="/" class="block">
            <img [src]="appConfig.style.img" [alt]="appConfig.title" class="block max-w-full h-auto mx-auto max-h-28" />
          </a>
        </h1>

        <button mat-stroked-button extended [matMenuTriggerFor]="profileMenu" class="max-w-100 profile-button">
          <mat-icon>account_circle</mat-icon>
          {{ user()?.Email }}
        </button>

        <button mat-icon-button (click)="toggleSearch()" class="my-2">
          <mat-icon>search</mat-icon>
        </button>
      </header>
    }

    @if (menuItems(); as categories) {
      <nav class="mt-4">
        @for (category of categories; track category.label) {
          @if (category.label) {
            <h3>{{ category.label | translate }}</h3>
          }

          <ul>
            @for (item of category.items; track item.label) {
              <li>
                <a
                  [routerLink]="item.route"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: item.exactMatch || false }"
                  [state]="{ resetFilters: true }">
                  @if (item.icon) {
                    <mat-icon>{{ item.icon }}</mat-icon>
                  }

                  {{ item.label | translate }}
                </a>
              </li>
            }
          </ul>
        }

        @if (selectedCompany.value) {
          @if (menuCompanies(); as companies) {
            <h3>{{ 'COMPANY' | translate }}</h3>

            <mat-form-field appearance="outline" class="w-full" [class.!hidden]="companies.length < 2">
              <mat-select
                [compareWith]="companyEquals"
                [formControl]="selectedCompany"
                (selectionChange)="onCompanyChange($event)">
                @for (company of companies; track $index) {
                  <mat-option [value]="company">
                    {{ company.CompanyName }}

                    @if (company.DepartmentName) {
                      <small class="block mt-1">{{ company.DepartmentName }}</small>
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <ul>
              @for (item of selectedCompany.value?.Menus; track item.type) {
                <li>
                  <a
                    [routerLink]="['companies', $safeNavigationMigration(selectedCompany.value?.CompanyID), item.route]"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: item.exactMatch }"
                    [state]="{ resetFilters: true }">
                    @if (item.icon) {
                      <mat-icon>{{ item.icon }}</mat-icon>
                    }

                    {{ item.label | translate }}
                  </a>
                </li>
              }
            </ul>
          }
        }
      </nav>
    }

    <footer class="flex flex-col items-center p-4">
      <div class="w-28 mx-auto bg-white rounded-2xl p-3 text-center relative">
        <div id="headway-badge"></div>
        <mat-icon>notifications_none</mat-icon>
        <div>Updates</div>
      </div>

      <div class="my-2">
        <small>{{ 'VERSION' | translate }} {{ appVersion }}</small>
      </div>

      @if (!environmentService.isProduction) {
        <div class="badge badge-error"> Environment: {{ environment() }} </div>
      }
    </footer>
  </mat-sidenav>

  @if (loggedInAs()) {
    <mat-toolbar class="auth-as-toolbar">
      <span>{{ 'LOGGED_IN_AS' | translate }}: {{ user()?.Email }}</span>
      <button mat-raised-button class="margin-left" color="warn" (click)="logoutAs()">
        {{ 'LOGOUT' | translate }}
      </button>
    </mat-toolbar>
  }

  <ng-container *canSee="UserType.OwnsStations">
    @if (
      companyService.company &&
      companyService.company.OwnedByLoggedInUser &&
      companyService.company.OwnerNeedsToApproveInformations
    ) {
      <mat-toolbar class="auth-as-toolbar">
        <span class="margin-right">
          {{ 'PLEASE_VALIDATE_BILLING_INFORMATION' | translate }}
        </span>
        <a mat-raised-button routerLink="/billing/settings" class="margin-left">
          {{ 'GO_TO_BILLING_INFORMATION' | translate }}
        </a>
      </mat-toolbar>
    }
  </ng-container>

  <router-outlet></router-outlet>
</mat-sidenav-container>

<mat-menu #profileMenu="matMenu">
  <a mat-menu-item routerLink="/settings">
    <mat-icon>settings</mat-icon>
    <span>{{ 'SETTINGS' | translate }}</span>
  </a>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'LOG_OUT' | translate }}</span>
  </button>
</mat-menu>
